import { ReactNode } from 'react';
import { Center, Container } from '@/components/ui/layout';
import { Card } from '@/components/ui/data-display';
import { AuthBackground } from './components/AuthBackground';
import { AuthHeader } from './components/AuthHeader';

export interface OnboardingLayoutProps {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  children: ReactNode;
  currentStep?: number;
  totalSteps?: number;
}

export function OnboardingLayout({
  children,
  currentStep,
  totalSteps
}: OnboardingLayoutProps) {
  return (
    <AuthBackground variant="onboarding">
      <AuthHeader showThemeToggle={false} showBackButton={false} />
      <Center mih="100vh" p="md">
        <Container size="md" w="100%">
          <Card variant="elevated" p="xl" radius="lg">
            {children}
          </Card>
        </Container>
      </Center>
    </AuthBackground>
  );
}

export default OnboardingLayout;
